import type { Attachment } from 'svelte/attachments';

export function keepInView(state: { inView: boolean }): Attachment {
	return (element) => {
		const intersectionObserverSupport =
			'IntersectionObserver' in window &&
			'IntersectionObserverEntry' in window &&
			'intersectionRatio' in window.IntersectionObserverEntry.prototype;

		if (intersectionObserverSupport) {
			const observer = new IntersectionObserver(
				(entries) => {
					entries.forEach((entry) => {
						state.inView = entry.isIntersecting;
					});
				},
				{ rootMargin: '-162px 0px 0px 0px' }, // 162 px is the height of the header, can't use CSS var here
			);
			if (element) {
				observer?.observe(element);
			}

			return () => {
				observer.unobserve(element);
			};
		}
	};
}
